import { render, staticRenderFns } from "./qualifica.vue?vue&type=template&id=9167dd06&scoped=true"
import script from "./qualifica.vue?vue&type=script&lang=js"
export * from "./qualifica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167dd06",
  null
  
)

export default component.exports